// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__1_Tvx","emails":"CreateEditClinics_emails__1SOtR","emailTagLabel":"CreateEditClinics_emailTagLabel__9DVgs"};